import { render, staticRenderFns } from "./ListTareaPage.vue?vue&type=template&id=420e855e"
import script from "./ListTareaPage.vue?vue&type=script&lang=js"
export * from "./ListTareaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports